import { Typography, Box, Grid, CircularProgress, Paper, Button, Card, CardContent, List, ListItem, Chip } from '@mui/material';

// import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { setSWOTResult } from 'store/reducers/actions';
import { useEffect } from 'react';
import BlockedInput from 'sections/askPage/BlockedInput';
import { DownloadOutlined } from '@ant-design/icons';
import IconButton from 'components/@extended/IconButton';
// import handleExportCSV from "services/exportService"
import Tooltip from '@mui/material/Tooltip';
import FreeBlockModal from 'sections/premiumBlock/FreeBlockModal';
import { openModal } from 'store/reducers/actions';
import LockIcon from '@mui/icons-material/Lock';
import FeedbackButtons from 'components/FeedbackButtons';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, Warning, TrendingUp, Security, CheckCircleOutline } from '@mui/icons-material';
import { useTheme } from '@mui/material';

const NewSwotGroup = ({ analysisData }) => {
  const dispatch = useDispatch();
  const [hoveredItems, setHoveredItems] = useState({});
  const plan = useSelector((state) => state.proAccountReducer.plan);
  const trialWasActivated = useSelector((state) => state.proAccountReducer.trial_was_activated);
  const isProUser = plan !== 'Free';
  const isModalOpen = useSelector((state) => state.modalReducer.isOpen);
  const isProPlan = plan === 'Pro' || plan === 'Pro+' || plan === 'Enterprise Pro Max' || plan === 'Enterprise Pro';

  const isLoading = useSelector((state) => state.loadingReducer.loadingSWOT);

  const task_id = useSelector((state) => state.currentTaskReducer.task_id);
  const swotResult = useSelector((state) => state.extendedAnalysisReducer.extendedAnalysisResults.swot);
  // console.log(swotResult)

  useEffect(() => {
    // Check which data was updated and set the respective state variabl
    dispatch(setSWOTResult(null));
  }, [task_id]);

  // console.log(task_id)

  const exportSWOTDataToCSV = () => {
    console.log(swotResult);
    const categories = Object.keys(swotResult);
    let csvContent = categories.map((category) => category).join(';') + ';\n';

    const maxRowCount = Math.max(...categories.map((category) => swotResult[category].length));
    for (let i = 0; i < maxRowCount; i++) {
      for (const category of categories) {
        const value = swotResult[category][i] || '';
        csvContent += `"${value}";`;
      }
      csvContent = csvContent.slice(0, -1) + '\n';
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = 'swot_analysis.csv';
    a.click();

    // Clean up
    window.URL.revokeObjectURL(url);
  };

  const handleTrialClick = () => {
    dispatch(
      openModal({
        title: 'Get access to extended report',
        subtitle: "Upgrade to Pro to view extended report. Don't miss out on accessing more insights!",
        trial: !trialWasActivated
      })
    );
  };

  const swotToRender = swotResult ? swotResult : null;

  const theme = useTheme();
  const getIconColor = (section) => {
    switch (section) {
      case 'Strengths':
        return theme.palette.success.main;
      case 'Weaknesses':
        return theme.palette.error.main;
      case 'Opportunities':
        return theme.palette.warning.main;
      case 'Threats':
        return theme.palette.secondary.main;
      default:
        return theme.palette.primary.main;
    }
  };
  const getIcon = (section) => {
    switch (section) {
      case 'Strengths':
        return <CheckCircleOutline sx={{ color: getIconColor(section), mr: 1 }} />;
      case 'Weaknesses':
        return <Warning sx={{ color: getIconColor(section), mr: 1 }} />;
      case 'Opportunities':
        return <TrendingUp sx={{ color: getIconColor(section), mr: 1 }} />;
      case 'Threats':
        return <Security sx={{ color: getIconColor(section), mr: 1 }} />;
      default:
        return <Lightbulb sx={{ color: getIconColor(section), mr: 1 }} />;
    }
  };
  const swotGradients = {
    Strengths: 'linear-gradient(135deg, #4caf50 0%, #2196F3 60%, #03A9F4 100%)',
    Weaknesses: 'linear-gradient(135deg, #ff9800 0%, #ff5722 60%, #f44336 100%)',
    Opportunities: 'linear-gradient(135deg, #3f51b5 0%, #673ab7 60%, #3F51B5 100%)',
    Threats: 'linear-gradient(135deg, #9c27b0 0%, #673AB7 60%, #3F51B5 100%)'
  };
  const getGradient = (section) => {
    return swotGradients[section] || swotGradients.Strengths;
  };
  const formatLabel = (str) =>
    str
      .replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  const renderListItems = (items, section, isBlurred) => {
    if (!items || !Array.isArray(items) || items.length === 0) return null;
    return (
      <List dense disablePadding sx={{ mt: 1 }}>
        {items.map((item, idx) => (
          <ListItem key={section + '_' + idx} disableGutters sx={{ alignItems: 'flex-start', mb: 1 }}>
            <Typography variant="body1" sx={isBlurred ? { filter: 'blur(7px)', opacity: 0.75, userSelect: 'none' } : {}}>
              {idx + 1}) {item}
            </Typography>
          </ListItem>
        ))}
      </List>
    );
  };

  return (
    <Box mt={3} id="swot">
      {!isProUser && isModalOpen ? <FreeBlockModal /> : null}
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Card
          sx={{
            mt: 3,
            borderRadius: 2,
            position: 'relative',
            isolation: 'isolate',
            '&::before': {
              content: '""',
              position: 'absolute',
              inset: 0,
              padding: '1px',
              borderRadius: 'inherit',
              background: 'linear-gradient(135deg, rgba(63,81,181,0.5) 0%, rgba(103,58,183,0.5) 60%, rgba(103,58,183,0.2) 100%)',
              WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              WebkitMaskComposite: 'xor',
              maskComposite: 'exclude',
              zIndex: -1
            },
            boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
            overflow: 'hidden'
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Lightbulb sx={{ color: 'primary.main', mr: 1 }} />
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  background: 'linear-gradient(135deg, #3f51b5 0%, #673ab7 60%, rgba(103,58,183,0.7) 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent'
                }}
              >
                SWOT Analysis
              </Typography>
              {!swotToRender && <CircularProgress size={24} sx={{ ml: 2 }} />}
              {swotToRender ? (
                <Tooltip title={!isProPlan ? '  Upgrade to Pro to export ' : 'Download as CSV'}>
                  <span>
                    <IconButton disabled={!isProPlan} size="large" onClick={exportSWOTDataToCSV}>
                      <DownloadOutlined />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : null}
            </Box>
            <Chip label="Powered by Askpot AI" size="small" color="primary" variant="outlined" sx={{ mb: 2 }} />
            {isLoading ? (
              <Box m={0} pt={0} sx={{ display: 'flex', justifyContent: 'center' }}>
                <BlockedInput text={'Analysis in progress, it can take about 60-90 seconds'} />
              </Box>
            ) : null}
            {swotToRender && (
              <Grid container spacing={3}>
                {['Strengths', 'Weaknesses', 'Opportunities', 'Threats'].map((section) => {
                  const items = swotToRender[section] || [];
                  const isStrengths = section === 'Strengths';
                  const halfStrengths = isStrengths ? Math.ceil(items.length / 4) : 0;
                  const visibleItems = isProUser ? items : isStrengths ? items.slice(0, halfStrengths) : [];
                  const blurredItems = isProUser ? [] : isStrengths ? items.slice(halfStrengths) : items;
                  return (
                    <Grid item xs={12} md={6} key={section}>
                      <motion.div whileHover={{ scale: 1.015 }} transition={{ duration: 0.2 }}>
                        <Box
                          id={`swot-${section.toLowerCase()}`}
                          sx={{
                            p: 2.5,
                            height: '100%',
                            borderRadius: 2,
                            bgcolor: 'background.paper',
                            position: 'relative',
                            isolation: 'isolate',
                            '&::before': {
                              content: '""',
                              position: 'absolute',
                              inset: 0,
                              padding: '1px',
                              borderRadius: 'inherit',
                              background: getGradient(section),
                              WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                              WebkitMaskComposite: 'xor',
                              maskComposite: 'exclude',
                              zIndex: -1
                            },
                            boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              boxShadow: '0 4px 8px rgba(0,0,0,0.03)'
                            }
                          }}
                          onMouseEnter={() => setHoveredItems((prev) => ({ ...prev, [section]: true }))}
                          onMouseLeave={() => setHoveredItems((prev) => ({ ...prev, [section]: false }))}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                            {getIcon(section)}
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 600,
                                background: getGradient(section),
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                color: 'transparent',
                                ml: 1
                              }}
                            >
                              {formatLabel(section)}
                            </Typography>
                          </Box>
                          {renderListItems(visibleItems, section, false)}
                          {blurredItems.length > 0 && (
                            <Box sx={{ position: 'relative', overflow: 'hidden', mt: 1 }}>
                              {renderListItems(blurredItems, section, true)}
                              <Box
                                sx={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  backgroundColor: 'rgba(255, 255, 255, 0.6)',
                                  opacity: 0,
                                  transition: 'opacity 0.3s',
                                  '&:hover': {
                                    opacity: 1
                                  },
                                  cursor: 'pointer'
                                }}
                                onClick={handleTrialClick}
                              >
                                <LockIcon />
                                <Typography variant="caption" color="primary" ml={1}>
                                  Unlock
                                </Typography>
                              </Box>
                            </Box>
                          )}
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <FeedbackButtons
                              blockId={`swot-${section.toLowerCase()}`}
                              blockType="swot"
                              blockTitle={section}
                              blockContent={JSON.stringify(swotToRender[section])}
                              taskId={task_id}
                              serviceName={analysisData ? analysisData['Service Name'] : 'N/A'}
                              isVisible={!!hoveredItems[section]}
                            />
                          </Box>
                        </Box>
                      </motion.div>
                    </Grid>
                  );
                })}
              </Grid>
            )}
            {!isProUser && (
              <Paper
                elevation={0}
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: 2,
                  backdropFilter: 'blur(5px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.6)',
                  textAlign: 'center',
                  mt: 2
                }}
              >
                <Typography variant="h5" color="primary" align="center" mb={1}>
                  Start your FREE 7 days trial to get access to all SWOT content!
                </Typography>
                <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleTrialClick}>
                  Unlock SWOT
                </Button>
              </Paper>
            )}
          </CardContent>
        </Card>
      </motion.div>
    </Box>
  );
};

export default NewSwotGroup;
